var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 64,
    viewBox: "0 0 86 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2067_10114)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.46898,
    y: 8.50023,
    width: 69.0312,
    height: 47.0212,
    rx: 5.50248,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.00045
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2289 40.5313H24.9864L21.805 28.3941C21.654 27.8358 21.3334 27.3422 20.8617 27.1095C19.6847 26.5249 18.3878 26.0597 16.9729 25.825V25.3577H23.8073C24.7506 25.3577 25.458 26.0597 25.5759 26.8749L27.2266 35.6299L31.4671 25.3577H35.5918L29.2289 40.5313ZM37.9504 40.5311H33.9436L37.2429 25.3576H41.2497L37.9504 40.5311ZM46.4335 29.5613C46.5514 28.7441 47.2588 28.2768 48.0842 28.2768C49.3811 28.1594 50.7939 28.3941 51.973 28.9767L52.6804 25.7097C51.5014 25.2425 50.2044 25.0078 49.0274 25.0078C45.1386 25.0078 42.3088 27.1096 42.3088 30.0266C42.3088 32.2456 44.3132 33.4108 45.7281 34.1128C47.2588 34.8127 47.8483 35.28 47.7304 35.9799C47.7304 37.0297 46.5514 37.497 45.3744 37.497C43.9595 37.497 42.5446 37.1471 41.2497 36.5625L40.5423 39.8314C41.9572 40.414 43.4879 40.6487 44.9028 40.6487C49.2632 40.764 51.973 38.6642 51.973 35.5126C51.973 31.5437 46.4335 31.3111 46.4335 29.5613ZM65.9955 40.5311L62.8141 25.3576H59.3969C58.6894 25.3576 57.982 25.8249 57.7462 26.5248L51.855 40.5311H55.9797L56.8029 38.3141H61.8708L62.3425 40.5311H65.9955ZM59.9859 29.4434L61.1629 35.1621H57.8636L59.9859 29.4434Z",
    fill: "#172B85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2067_10114",
    x: 0.406281,
    y: 0.437531,
    width: 85.1564,
    height: 63.1464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78123
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2067_10114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2067_10114",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.35dd9c9b219243d8bb1ff9b2bf87b49b.svg";
export { ForwardRef as ReactComponent };